<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="Wrapper" class="flexContainerColCenter" style="overflow:auto">
            <h2>{{ $t('tournamentregistrationOverviewAll.Header') }}</h2>
            <h3>{{ $t('tournamentregistrationOverviewAll.Subheader1') }}</h3>
            <Grid ref="gridTurniere"
                  :style="{ width: '500px' }"
                  :data-items="gridDataTurniereComputed"
                  :loader="loaderTurniere"
                  :selected-field="selectedFieldTurniere"
                  @rowclick="onRowClickedTurniere"
                  :columns="columnsTurniere">
                <grid-norecords>{{ $t('tournamentregistrationOverviewAll.NotificationNoData') }}</grid-norecords>
            </Grid>
            <br />
            <br />
            <h3>{{ $t('tournamentregistrationOverviewAll.Subheader2') }}</h3>
            <radiogroup :data-items="dataItemsRadioGroup" :layout="'horizontal'" @change="handleChangeRadioGroup" :value="checked" />
            <br />
            <br />
            <h3>{{ $t('tournamentregistrationOverviewAll.Subheader3') }}</h3>
            <div id="Anzeige">
                <kbutton title="$t('tournamentregistrationOverviewAll.ExcelExport')" :theme-color="'primary'" @click="exportExcelWithComp">
                    {{ $t('tournamentregistrationOverviewAll.ExcelExport') }}
                </kbutton>
                &nbsp;
                <kbutton title="$t('tournamentregistrationOverviewAll.PDFExport')" :theme-color="'primary'" @click="exportPDFWithComp">
                    {{ $t('tournamentregistrationOverviewAll.PDFExport') }}
                </kbutton>
                <br />
                <pdfexport ref="gridPDFExportEinzel"
                           :scale="0.6"
                           :paper-size="'A4'"
                           :landscape="true"
                           margin="2cm"
                           fileName="ExportGesamtEinzel.pdf">
                    <Grid v-if="visibleEinzel"
                          :style="{ height: '500px' }"
                          ref="gridAnzeigeEinzel"
                          :data-items="gridDataEinzel"
                          :loader="loaderEinzel"
                          :columns="columnsEinzel">
                        <grid-norecords>{{ $t('tournamentregistrationOverviewAll.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </pdfexport>
                <pdfexport ref="gridPDFExportPaarTeam"
                           :scale="0.6"
                           :paper-size="'A4'"
                           :landscape="true"
                           margin="2cm"
                           fileName="ExportGesamtPaarTeam.pdf">
                    <Grid v-if="!visibleEinzel"
                          :style="{ height: '500px' }"
                          ref="gridAnzeigePaarTeam"
                          :data-items="gridDataPaarTeam"
                          :loader="loaderPaarTeam"
                          :columns="columnsPaarTeam">
                        <grid-norecords>{{ $t('tournamentregistrationOverviewAll.NotificationNoData') }}</grid-norecords>
                    </Grid>
                </pdfexport>
            </div>
            <br />
            <br />
        </div>
    </div>
</template>

<script>
    import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
    import { RadioGroup } from '@progress/kendo-vue-inputs';
    import { Button } from '@progress/kendo-vue-buttons';
    import { GridPdfExport } from '@progress/kendo-vue-pdf';
    import { saveExcel } from '@progress/kendo-vue-excel-export';
    import config from "@/appdata/config.json";
    import store from '@/store/store.js';

    export default {
        components: {
            Grid: Grid,
            "grid-norecords": GridNoRecords,
            "grid-toolbar": GridToolbar,
            'pdfexport': GridPdfExport,
            'kbutton': Button,
            radiogroup: RadioGroup,
            store
        },
        data: function () {
            return {
                baseUrlTurniere: '',
                baseUrlEinzel: '',
                baseUrlPaarTeam: '',
                init: { method: "GET", accept: "application/json", headers: {} },
                pageable: false,
                gridDataTurniere: [],
                gridDataEinzel: [],
                gridDataPaarTeam: [],
                selectedFieldTurniere: "selectedTurniere",
                selectedPrimTurniere: 0,
                columnsTurniere: [
                    { field: "prim", editable: false, hidden: true, width: 100, title: "Prim" },
                    { field: "name", editable: false, width: 230, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderName') },
                    { field: "ort", editable: false, width: 120, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderLocation') },
                    { field: "datum", type: "date", format: "{0:dd.MM.yyyy}", editable: false, width: 100, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderDate') }
                ],
                columnsEinzel: [
                    { field: "klasse", editable: false, width: 350, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderClass') },
                    { field: "formenart", editable: false, hidden: true, width: 120, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderPoomsaetype') },
                    { field: "startnummer", editable: false, width: 85, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderStartNr') },
                    { field: "name", editable: false, width: 150, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderName') },
                    { field: "vorname", editable: false, width: 150, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderFirstName') },
                    { field: "verein", editable: false, width: 400, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderClub') },
                    { field: "form1", editable: false, hidden: true, width: 200, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderPoomsae1') },
                    { field: "form2", editable: false, hidden: true, width: 200, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderPoomsae2') }
                ],
                columnsPaarTeam: [
                    { field: "klasse", editable: false, width: 350, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderClass') },
                    { field: "formenart", editable: false, hidden: true, width: 120, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderPoomsaetype') },
                    { field: "startnummer", editable: false, width: 85, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderStartNr') },
                    { field: "anzeigeName", editable: false, width: 300, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderPairTeamName') },
                    { field: "verein", editable: false, width: 400, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderClub') },
                    { field: "form1", editable: false, hidden: true, width: 200, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderPoomsae1') },
                    { field: "form2", editable: false, hidden: true,width: 200, title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderPoomsae2') }
                ],
                loaderTurniere: false,
                loaderEinzel: false,
                loaderPaarTeam: false,
                totalTurniere: 0,
                totalEinzel: 0,
                totalPaarTeam: 0,
                dataItemsRadioGroup: [
                    {
                        label: this.$t('tournamentregistrationOverviewAll.LabelRadioGroupSingle'),
                        value: "1",
                    },
                    {
                        label: this.$t('tournamentregistrationOverviewAll.LabelRadioGroupPairTeam'),
                        value: "2",
                    },
                ],
                checked: '1',
                visibleEinzel: true
            };
        },
        computed: {
            gridDataTurniereComputed() {
                return this.gridDataTurniere.map((item) => ({ prim: item.prim, name: item.name, datum: item.datum, ort: item.ort, selectedTurniere: (item.prim === this.selectedPrimTurniere) }));
            }
        },
        created: function () {
            this.baseUrlTurniere = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TurniereManagement";
            this.getDataTurniere();
        },
        methods: {
            onRowClickedTurniere(event) {
                this.selectedPrimTurniere = event.dataItem.prim;
                //Grid neu laden
                if (this.checked === '1') {
                    this.visibleEinzel = true;
                    this.baseUrlEinzel = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TurnieranmeldungenUebersichtEinzelByTurnierManagement?RefTurniere=" + this.selectedPrimTurniere;
                    this.getDataEinzel();
                } else {
                    this.visibleEinzel = false;
                    this.baseUrlPaarTeam = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TurnieranmeldungenUebersichtPaarTeamByTurnierManagement?RefTurniere=" + this.selectedPrimTurniere;
                    this.getDataPaarTeam();
                }
            },
            getDataTurniere: function (initial) {
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlTurniere,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        that.totalTurniere = total;
                        that.gridDataTurniere = data;
                        this.loaderTurniere = false;
                    });
            },
            getDataEinzel: function (initial) {
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlEinzel,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        that.totalEinzel = total;
                        that.gridDataEinzel = data;
                        this.loaderEinzel = false;
                    });
            },
            getDataPaarTeam: function (initial) {
                console.log("---->", initial);
                const that = this;
                this.loader = true;

                fetch(
                    this.baseUrlPaarTeam,
                    //+ "?" + toODataString(this.dataState) + "&$count=true",
                    this.init
                )
                    .then((response) => response.json())
                    .then((json) => {
                        const total = json["@odata.count"];
                        const data = json["data"];
                        that.totalPaarTeam = total;
                        that.gridDataPaarTeam = data;
                        this.loaderPaarTeam = false;
                    });
            },
            handleChangeRadioGroup(e) {
                this.checked = e.value;
                //Grid neu laden
                if (this.checked === '1') {
                    this.visibleEinzel = true;
                    this.gridDataEinzel = [];
                    this.baseUrlEinzel = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TurnieranmeldungenUebersichtEinzelByTurnierManagement?RefTurniere=" + this.selectedPrimTurniere;
                    this.getDataEinzel();
                } else {
                    this.visibleEinzel = false;
                    this.gridDataPaarTeam = [];
                    this.baseUrlPaarTeam = config[0].ServiceUrl + config[0].ServiceUrlPort + "/TurnieranmeldungenUebersichtPaarTeamByTurnierManagement?RefTurniere=" + this.selectedPrimTurniere;
                    this.getDataPaarTeam();
                }
            },
            exportPDFWithComp: function () {
                if (this.visibleEinzel === true) {
                    this.$refs.gridPDFExportEinzel.save(this.gridDataEinzel);
                } else {
                    this.$refs.gridPDFExportPaarTeam.save(this.gridDataPaarTeam);
                }
            },
            exportExcelWithComp: function () {
                if (this.visibleEinzel === true) {
                    saveExcel({
                        data: this.gridDataEinzel,
                        fileName: "ExportEinzel",
                        columns: [
                            { field: 'klasse', title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderClass') },
                            { field: 'startnummer', title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderStartNr') },
                            { field: 'name', title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderName') },
                            { field: 'vorname', title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderFirstName') },
                            { field: 'verein', title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderClub') },
                        ]
                    });
                } else {
                    saveExcel({
                        data: this.gridDataPaarTeam,
                        fileName: "ExportPaarTeam",
                        columns: [
                            { field: 'klasse', title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderClass') },
                            { field: 'startnummer', title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderStartNr') },
                            { field: 'anzeigeName', title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderPairTeamName') },
                            { field: 'verein', title: this.$t('tournamentregistrationOverviewAll.GridColumnHeaderClub') },
                        ]
                    });
                }
            },
        },
    };
</script>

 Add "scoped" attribute to limit CSS to this component only
<style scoped>
    @import '../css/main.css';
</style>
